// import React from 'react';
import { Container, Row } from 'reactstrap';
import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
import './styles/App.css';
import TopTitle from './TopTitle';
import axios from 'axios';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import queryString from 'query-string';
import {Select,currentDate, formatDate,returnDate,instance} from './common';
import downArrow from './img/eva_arrow-ios-downward-fill-1.png';
import upArrow from './img/eva_arrow-ios-downward-fill.png';
import whiteTel from './img/fluent_call-20-regular.png';
import clip from './img/clip.png';
import blackCalander from './img/calendar_b.png';


registerLocale("ko", ko);

function SetInputGroups({sigongArray,productArray,inputBox,jaegoArray,setJaego}){
    const btnWrap = {
        position: "absolute",
        right: "0",
        border: "1px solid #c4c4c4",
        borderRadius: "5px",
        width: "120px",
        height: "30px"
    }
    const btnWidth1 = {
        width: "30%",
        borderRight: "1px solid #c4c4c4",
        color: "#c4c4c4"
    }
    const btnWidth2 = {
        width: "40%",
        borderRight: "1px solid #c4c4c4"
    }
    const btnWidth3 = {
        width: "30%"
    }
    const cColor1 = {
        color: "#c4c4c4",
        fontSize: "17px",
        fontWeight: "bold"
    }
    const cColor2 = {
        color: "#c4c4c4",
        fontSize: "17px"
    }
    const [data, setData] = useState([]);
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const {u_id} = parsedsigong;

    useEffect(() => {

         
        let obj = {
            p_u_id:u_id,
        }
        
        const fetchData = async () => {

          instance.post('/jaego/my-product', obj).then(function (res) {
              console.log('res : ', res)
                setData(res.data.rows);
          });


    
        };
    
        fetchData();
    
      }, []);
      


    const [s_inputs, s_setInputs] = useState(JSON.parse(productArray));

    const plus = () => {
        s_setInputs([...s_inputs,1]);
    }

    const minus = () => {
        s_setInputs(s_inputs.filter((v,i)=> i !== s_inputs.length-1));
    }

    const onChange = (e) => {
        const {name,value} = e.target;
        instance.post('/jaego/count-check', {jae_id:value}).then(function (res) {
            if(res.data[0].pr_limit == 0){
                alert('수량이 없습니다.')
                e.target.value = '';
            }else{
                let count = 0;
                document.querySelectorAll('.product-option').forEach(function(v,i){
                    if(v.value == value){
                        
                        if( document.querySelectorAll('.product-input').length > v.dataset.d_limit * v.dataset.count){
                            if(count == 0){
                                alert('수량이 없습니다.');
                                count++;
                                e.target.value = '';
                            }
                        }else{
                            setJaego([...jaegoArray,value])
                        }
                        return false;

                    }
                });
                
            }
        });
        
    
       
    }
    console.log('jaegoArray :' , jaegoArray)
    

    return (
        <>
        {
            s_inputs.map((v,i) => <div className="mb-4" key={i}>
            <div className="row p-0">
                <div className="col pl-0 text-center">
                    <input  
                    className="sigong-input" 
                    type="text" 
                    style={inputBox} 
                    name={"sigong-"+i} 
                    value={JSON.parse(sigongArray)[i]}
                    />
                </div>
                <div className="col pr-0 text-center">
                    <select className="product-input form-control" type="text" name={"product-"+i} value={JSON.parse(productArray)[i]} onChange={onChange}>
                        <option className="product-option" value="">-</option>
                        {
                            data.map(v => 
                            <option 
                            className="product-option"
                            key={v.jae_id} 
                            value={v.jae_id}
                            data-jae_id={v.jae_id} 
                            data-limit={v.pr_limit}
                            data-d_limit={v.data_limit}
                            data-count={v.pr_count}>
                            {v.pr_name}
                            </option>
                            )
                        }
                    </select>
                </div>
            </div>
        </div>)
        }
        <div className="position-relactive">
            <div className="btnWrap row p-0" style={btnWrap}>
                <div className="text-center" style={btnWidth1} onClick={minus}><span style={cColor1}>-</span></div>
                <div className="text-center" style={btnWidth2}><span style={cColor2}>{s_inputs.length}</span></div>
                <div className="text-center" style={btnWidth3} onClick={plus}><span style={cColor1}>+</span></div>
            </div>
        </div>
        </>
        
    )
}


function InputGroups({inputBox,jaegoArray,setJaego}){

    const btnWrap = {
        position: "absolute",
        right: "0",
        border: "1px solid #c4c4c4",
        borderRadius: "5px",
        width: "120px",
        height: "30px"
    }
    const btnWidth1 = {
        width: "30%",
        borderRight: "1px solid #c4c4c4",
        color: "#c4c4c4"
    }
    const btnWidth2 = {
        width: "40%",
        borderRight: "1px solid #c4c4c4"
    }
    const btnWidth3 = {
        width: "30%"
    }
    const cColor1 = {
        color: "#c4c4c4",
        fontSize: "17px",
        fontWeight: "bold"
    }
    const cColor2 = {
        color: "#c4c4c4",
        fontSize: "17px"
    }

    const [inputs, setInputs] = useState([]);

    const plus = () => {
        setInputs([...inputs,1]);
    }

    const minus = () => {
        setInputs(inputs.filter((v,i)=> i !== inputs.length-1));
    }

    const [data, setData] = useState([]);
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const {u_id} = parsedsigong;

    useEffect(() => {

         
        let obj = {
            p_u_id:u_id,
        }
        
        const fetchData = async () => {

          instance.post('/jaego/my-product', obj).then(function (res) {
              console.log('res : ', res)
                setData(res.data.rows);
          });


    
        };
    
        fetchData();
    
      }, []);
      

      const onChange = (e) => {
        const {name,value} = e.target;
        console.log('value : ', value)
        document.querySelectorAll('.product-option').forEach(function(v,i){
            if(v.value == value){
                let pr_count = v.dataset.count; // 2
                let currentLimit = v.dataset.limit;   // 6
                currentLimit = currentLimit - 1 ;  // 5

                if(currentLimit >= v.dataset.d_limit){   

                    if(currentLimit % v.dataset.d_limit == 0){

                        pr_count = pr_count - 1;

                    }

                }else{

                    if(currentLimit == 0){
                        pr_count = pr_count - 1;
                    }

                }

                let obj = {
                    jae_id:v.dataset.jae_id,
                    pr_count:pr_count,
                    pr_limit:currentLimit
                }
        
                console.log('만들어진 obj : ', obj)
                setJaego([...jaegoArray,obj])
                return false;
            }
        });


     
    }

    console.log('jaegoArray : ', jaegoArray)



    return (
        <>
         {
             inputs.map((v,i) => <div className="mb-4" key={i}>
             <div className="row p-0">
                 <div className="col pl-0 text-center">
                     <input className="sigong-input" type="text" style={inputBox} name={"sigong-"+i}/>
                 </div>
                 <div className="col pr-0 text-center">
                    <select className="product-input form-control" type="text" name={"product-"+i} onChange={onChange}>
                        <option className="product-option" value="">-</option>
                        {
                            data.map(v => 
                                <option
                                className="product-option"
                                key={v.jae_id} 
                                value={v.pr_name} 
                                data-jae_id={v.jae_id} 
                                data-d_limit={v.data_limit}
                                data-limit={v.pr_limit} 
                                data-count={v.pr_count}>{v.pr_name}
                                </option>
                                )
                        }
                    </select>
                </div>
             </div>
         </div>)
         }
        <div className="position-relactive">
            <div className="btnWrap row p-0" style={btnWrap}>
                <div className="text-center" style={btnWidth1} onClick={minus}><span style={cColor1}>-</span></div>
                <div className="text-center" style={btnWidth2}><span style={cColor2}>{inputs.length}</span></div>
                <div className="text-center" style={btnWidth3} onClick={plus}><span style={cColor1}>+</span></div>
            </div>
        </div>
        </>
    )
}

const Example = ({carmaster,inputs,setInputs,photo_before,photo_after,location}) => {
    const query = queryString.parse(location.search);

    const r_id = query.r_id;

    const session = JSON.parse(window.sessionStorage.result);
    const {u_login_id} = session;


    const [one,setone] = useState(false);
    const [two,setTwo] = useState(false);
    const [three,setthree] = useState(false);

    // 첫번째 collapse
    const [isOpen, setIsOpen] = useState(false);
    const toggle = (e) => {

        const {name} = e.target.dataset;
        if(name == 'one'){
            setone(!one);
        }
        setIsOpen(!isOpen);
    }

    // 두번째 collapse
    const [isOpen2, setIsOpen2] = useState(false);
    const toggle2 = (e) => {

        const {name} = e.target.dataset;
        if(name == 'two'){
            setTwo(!two);
        }
        setIsOpen2(!isOpen2);
    }
  
    // 세번째 collapse
    const [isOpen3, setIsOpen3] = useState(false);
    const toggle3 = (e) => {

        const {name} = e.target.dataset;
        if(name == 'three'){
            setthree(!three);
        }
        setIsOpen3(!isOpen3);
    }

    const arrowSize = {
        width: '18px',
        position: 'absolute',
        right: '0'
    }

    const textWrap = {
        borderBottom: '1px solid #c4c4c4',
        backgroundColor: '#f8f8f8',
        padding: '10px'
    }

    const telSize = {
        width: '16px'
    }


    // file upload
    
    const uploadImage = (e) => {
        const {id,files} = e.target;
        let file = files[0];
        let dir = u_login_id;

        let formData = new FormData();
        formData.append('dir', dir);
        formData.append('img', file);
        fileUpload(formData,id);
    }

    const fileUpload = (formdata,id) => {
        const fetchData = async () => {
            instance.post('/file/image',formdata,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                  }
            })
            .then(function(res){
        
                let path = res.data.path;
                path = path.slice(7,path.length)
                let url = 'https://abys-service.co.kr:3001//'+path;
    
                
                if(id == 'file-upload'){
                    setInputs({
                        ...inputs,
                        photo_before:[...photo_before,url]
                    })
                }

                if(id == 'file-upload2'){
                    setInputs({
                        ...inputs,
                        photo_after:[...photo_after,url]
                    })
                }
                
                
            });
        
        };
    
        fetchData();
    }
    
    const ipgoFinish = (e) => {


        
        const obj ={
            obj:inputs
        }

        const fetchData = async () => {

                let obj2 = {
                    r_ipgo:currentDate(),
                    r_status:'입고완료'
                }
    
                let updateObj = {
                    obj:obj2,
                    whereField:'r_id',
                    whereValue:r_id
                }
                
                instance.post('/reserve/update', updateObj).then(function (res) {
                 
                    alert('정상적으로 입고완료 되었습니다.');
                    setr_ipgo(currentDate());
                    instance.post('/users/push_one',{u_login_id:carmaster}).then(function(res){
                           
                    });

                });
        };

        fetchData();
        
    }


    const gumsuFinish = (e) => {

        const fetchData = async () => {

                let obj2 = {
                    r_gumsu:currentDate(),
                    r_status:'검수완료'
                }
    
                let updateObj = {
                    obj:obj2,
                    whereField:'r_id',
                    whereValue:r_id
                }
                
                instance.post('/reserve/update', updateObj).then(function (res) {
          
                    alert('정상적으로 검수완료 되었습니다.');
                    setr_gumsu(currentDate());
                    instance.post('/users/push_two',{u_login_id:carmaster}).then(function(res){
                           
                    });

                });
        };

        fetchData();
        
    }

    const workFinish = (e) => {

        const fetchData = async () => {

                let obj2 = {
                    r_enddate:currentDate(),
                    r_status:'작업완료'
                }
    
                let updateObj = {
                    obj:obj2,
                    whereField:'r_id',
                    whereValue:r_id
                }
                
                instance.post('/reserve/update', updateObj).then(function (res) {
             
                    alert('정상적으로 작업완료 되었습니다.');
                    setr_enddate(currentDate());
                    instance.post('/users/push_three',{u_login_id:carmaster}).then(function(res){
                           
                    });

                });
        };

        fetchData();
        
    }


    const [data, setData] = useState([]);
    // 데이터 조회
    const loadobj ={
        r_id:r_id
    }
    const [r_ipgo, setr_ipgo] = useState('');
    const [r_gumsu, setr_gumsu] = useState('');
    const [r_enddate, setr_enddate] = useState('');

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/reserve/r_id',loadobj).then(function (res) {
                setData(res.data[0])
                console.log('res.data[0].r_ipgo : ', res.data[0].r_ipgo)
                if(res.data[0].r_ipgo){
                    setr_ipgo(res.data[0].r_ipgo);
                }
                if(res.data[0].r_gumsu){
                    setr_gumsu(res.data[0].r_gumsu);
                }
                if(res.data[0].r_enddate){
                    setr_enddate(res.data[0].r_enddate);
                }
                   
                
            });

        };

        fetchData();

    }, []);

    console.log('r_ipgo : ', r_ipgo)
    console.log('r_gumsu : ', r_gumsu)
    return (
    <>
      <div>
        <div onClick={toggle} data-name="one" style={{fontWeight:'bold', borderBottom: '1px solid #c4c4c4'}} className="py-3 position-relactive">
            
            {
                r_ipgo
                ?<span data-name="one">1. 차량 입고완료</span>
                :<span data-name="one">1. 차량 입고</span>
            }
            
            
            
            {
                one
                ?<img src={upArrow} style={arrowSize}  data-name="one"/>
                :<img src={downArrow} style={arrowSize} data-name="one"/>
            }
            
        </div>
        <Collapse isOpen={isOpen}>
          <div style={textWrap}>
             <div className="row p-0">
                 <div className="col-10 pr-2">
                    <span className="form-control" id="jIpgo">{r_ipgo}</span>
                 </div>
                 <div className="col-2 pl-2">
                    <span className="btn btn-primary" onClick={ipgoFinish}>완료</span>
                 </div>
                 
             </div>
          </div>
        </Collapse>
      </div>
      <div>
        <div onClick={toggle2} data-name="two" style={{fontWeight:'bold', borderBottom: '1px solid #c4c4c4'}} className="py-3 position-relactive">
            
            {
                r_gumsu
                ?<span data-name="two">2. 검수완료</span>
                :<span data-name="two">2. 검수</span>
            }
            
            
            {
                two
                ?<img src={upArrow} style={arrowSize}  data-name="two"/>
                :<img src={downArrow} style={arrowSize} data-name="two"/>
            }
            
        </div>
        <Collapse isOpen={isOpen2}>
          <div style={textWrap}>
             <div className="row p-0 position-relactive mb-4">
                 <span className="btn btn-primary btn-sm mr-3"><img src={whiteTel} style={telSize}/> 고객</span>
                 <span className="btn btn-primary btn-sm"><img src={whiteTel} style={telSize}/> 카마스터</span>
                 <span className="btn btn-primary" style={{position: 'absolute', right: '0'}} onClick={gumsuFinish}>완료</span>
             </div>
             <div>                 
                 <label htmlFor="file-upload" className="text-center" onChange={uploadImage}>사진 업로드 <img src={clip} style={{width: '18px', marginTop: '-5px'}}/><input id="file-upload" type="file" className="d-none" accept="image/jpeg, image/jpg" multiple/></label>
                 <div>
                    <div className="mt-3 position-relactive">
                        {
                            photo_before.length !=0
                            &&
                            photo_before.map(v => <div className="p_midimg" style={{background:'url(\''+v+'\')'}}></div>)
                        } 
                    </div>
                </div>
             </div>
          </div>
        </Collapse>
      </div>
      <div>
        <div onClick={toggle3} data-name="three" style={{fontWeight:'bold', borderBottom: '1px solid #c4c4c4'}} className="py-3 position-relactive">
            
            {
                r_enddate
                ?<span data-name="three">3. 작업완료</span>
                :<span data-name="three">3. 작업</span>
            }
            
            
            {
                three
                ?<img src={upArrow} style={arrowSize}  data-name="three"/>
                :<img src={downArrow} style={arrowSize} data-name="three"/>
            }

        </div>
        <Collapse isOpen={isOpen3}>
          <div style={textWrap}>
             <div className="row p-0 position-relactive mb-4">
                 <span className="btn btn-primary btn-sm mr-3"><img src={whiteTel} style={telSize}/> 고객</span>
                 <span className="btn btn-primary btn-sm"><img src={whiteTel} style={telSize}/> 카마스터</span>
                 <span className="btn btn-primary" style={{position: 'absolute', right: '0'}} onClick={workFinish}>완료</span>
             </div>
             <div>
                 <label htmlFor="file-upload2"  onChange={uploadImage}>사진 업로드 <img src={clip} style={{width: '18px', marginTop: '-5px'}}/><input id="file-upload2" type="file" className="d-none" accept="image/jpeg, image/jpg" multiple/></label>
                 <div>
                    <div className="mt-3 position-relactive">
                        {
                            photo_after.length !=0
                            &&
                            photo_after.map(v => <div className="p_midimg" style={{background:'url(\''+v+'\')'}}></div>)
                        } 
                    </div>
                </div>
             </div>
          </div>
        </Collapse>
      </div>
    </>
    );
  }


function CustomerInfo({location, history}) {

    const query = queryString.parse(location.search);
    
    const r_id = query.r_id;


    //유저 session
    const session = JSON.parse(window.sessionStorage.result);


    //시공점 data 가져오기
    const u_sigong = session.u_sigong;

    
    const obj3 ={
        si_id:u_sigong
    }
    

    //reserve data 가져오기
    const obj ={
        r_id:r_id
    }

    const [u_login_id, setU_login_id] = useState('');
    const [contract_num, setContract_num] = useState('');
    const [si_name, setSi_name] = useState('');

    const [jaegoArray, setJaego] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/reserve/r_id', obj).then(function (res) {
                setContract_num(res.data[0].contract_num);

                let obj2 = {
                    u_id:res.data[0].ag_id
                }
               
                instance.post('/users/u_id', obj2).then(function (res) {
                    setU_login_id(res.data[0].u_login_id);
                   
                });
            });


            instance.post('/sigong/id', obj3).then(function (res) {
               
                setSi_name(res.data[0].si_name);
               
            });
        };

        fetchData();

    }, []);


    const [startDate, setStartDate] = useState('');

    const TopBorderBottom = {
        borderBottom: "2px solid #111",
        fontSize: "18px",
        fontWeight: "bold",
        paddingBottom: "5px"
    }
    const inputBox = {
        border: "0",
        borderBottom: "1px solid #c4c4c4"
    }
    const borderBot = {
        borderBottom: "2px solid #111"
    }
    const btnWhite = {
        border: "1px solid #c4c4c4",
        borderRadius: "5px",
        color: "#676767",
        width: "100%",
        padding: "4px"
    }

    const mbDown = {
        marginBottom: "80px"
    }
    const redFont = {
        color: "red",
        fontSize: "12px"
    }

    
    //insert inputs
    const [inputs, setInputs] = useState({
        u_id:'',
        u_id2: u_login_id,
        u_type:'',
        represent:0,
        represent2:0,
        u_car_name:'',
        u_car_number:'',
        u_car_age:'',
        u_car_color:'',
        u_car_date:'',
        u_app_date:currentDate(),
        sigongArray:'',
        productArray:'',
        suntint:'',
        blackbox:'',
        coating:'',
        ppf:'',
        detail:'',
        film:'',
        photo_before:[],
        photo_after:[],
        film:'',
        rep_r_id: r_id
    });

    const {u_id,u_id2,u_type,represent,represent2,u_car_name,u_car_number,u_car_age,u_car_color,u_car_date,u_app_date,sigongArray,productArray,suntint,blackbox,coating,ppf,detail,film,rep_r_id,photo_before,photo_after} = inputs;

    const onChange = (e) => {
        const {name,value} = e.target;
 
        setInputs({
            ...inputs,
            [name]:value
        })

    }


    const insert = () => {

        let sigongArray = [];
        let productArray = [];
        document.querySelectorAll('.sigong-input').forEach(function(v,i){
            sigongArray[i] = v.value;
        });
        document.querySelectorAll('.product-input').forEach(function(v,i){
            productArray[i] = v.value;
        });

        inputs.u_id2 = u_login_id;
        inputs.sigongArray = JSON.stringify(sigongArray);
        inputs.productArray = JSON.stringify(productArray);

        if(startDate){
            inputs.u_car_date = formatDate(startDate)
        }

        inputs.photo_before = JSON.stringify(photo_before)
        inputs.photo_after = JSON.stringify(photo_after)
        
        
        const obj ={
            obj:inputs
        }

        const fetchData = async () => {
            
            instance.post('/rep_car/insert', obj).then(function (res) {
               
                // setSi_name(res.data[0].si_name);
                let obj2 = {
                    co_car_id:r_id
                }
    
                let updateObj = {
                    obj:obj2,
                    whereField:'co_number',
                    whereValue:contract_num
                }
    
                instance.post('/contract/update', updateObj).then(function (res) {
                    jaegoArray.forEach(function(item){
                        instance.post('/jaego/count-update', {jae_id:item}).then(function (res) {
                            
                           
                        });
        
                    });                 
    
                 
                    alert('정상적으로 입력되었습니다.');
                    history.goBack();

                    
                });
               
            });


        };

        fetchData();

    }

    // 데이터 조회
    const loadobj ={
        r_id:r_id
    }

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/rep_car/work_id',loadobj).then(function (res) {
               
                if(res.data[0]){
                    setInputs({
                        ...res.data[0],
                        photo_before:JSON.parse(res.data[0].photo_before),
                        photo_after:JSON.parse(res.data[0].photo_after)
                    });
                    setStartDate(returnDate(res.data[0].u_car_date))
                }
                
                
            });

        };

        fetchData();

    }, []);

    
    


    // 수정
    const modify = () => {

        let sigongArray = [];
        let productArray = [];
        document.querySelectorAll('.sigong-input').forEach(function(v,i){
            sigongArray[i] = v.value;
        });
        document.querySelectorAll('.product-input').forEach(function(v,i){
            productArray[i] = v.value;

        });

        inputs.u_id2 = u_login_id;
        inputs.sigongArray = JSON.stringify(sigongArray);
        inputs.productArray = JSON.stringify(productArray);
        inputs.photo_before = JSON.stringify(photo_before)
        inputs.photo_after = JSON.stringify(photo_after)
        inputs.u_app_date = inputs.u_app_date;

        if(startDate){
            inputs.u_car_date = formatDate(startDate)
        }       

        
        let updateObj = {
            obj:inputs,
            whereField:'rep_r_id',
            whereValue:inputs.rep_r_id
        }

        const fetchData = async () => {
            
            instance.post('/rep_car/update', updateObj).then(function (res) {
                jaegoArray.forEach(function(item){
                    instance.post('/jaego/count-update', {jae_id:item}).then(function (res) {
                        
                       
                    });
    
                });                 

             
                alert('정상적으로 수정되었습니다.');
                history.goBack();
            });

        };

        fetchData();

    }



    const goPage = () => {
        history.push('/workdetailpage?r_id='+r_id);
    }


    return (
        <>
            <Container>
                {
                    productArray
                    ?<TopTitle title="작업 내역 수정" />
                    :<TopTitle title="작업 내역 입력" />
                }
                {
                    productArray
                    ?<div style={TopBorderBottom} className="mb-4">차량 정보 수정</div>
                    :<div style={TopBorderBottom} className="mb-4">차량 정보 등록</div>
                }
                
                <div style={borderBot}>
                    <div className="mb-4">
                        <label className="mb-3">출고점</label>
                        <input type="text" style={inputBox} value={si_name}/>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">출고 날짜</label>
                        <div className="px-0 wrap_calender">
                        <img className="icon_calender3" src={blackCalander}/>
                            <DatePicker
                                locale="ko"
                                dateFormat="yyyy-MM-dd"
                                className="form-control text-center text-primary culDate"
                                selected={startDate}
                                onChange={date => {setStartDate(date)}}
                            />
                        </div>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">차종</label>
                        <input type="text" style={inputBox} name="u_car_name" onChange={onChange} value={u_car_name}/>
                    </div>
                    <div className="mb-5">
                        <label className="mb-3">차량색상</label>
                        <select className="form-control" onChange={onChange} name="u_car_color" value={u_car_color}>
                            <option value="">-</option>
                            <option value="화이트">화이트</option>
                            <option value="블랙">블랙</option>
                            <option value="그레이">그레이</option>
                            <option value="실버">실버</option>
                        </select>
                    </div>
                </div>
                <div className="upDown mb-5">
                    <Example photo_before={photo_before} photo_after={photo_after} inputs={inputs} setInputs={setInputs} location={location} carmaster={u_login_id}/>
                </div>
                <div style={TopBorderBottom} className="mb-4">시공제품</div>
                <div>
                    <div style={mbDown}>
                        <div className="row p-0 mb-3">
                            <div className="col-6 pl-0 pr-3">
                                <span className="btn" style={btnWhite}>시공부위</span>
                            </div>
                            <div className="col-6 pr-0 pl-3">
                                <span className="btn" style={btnWhite}>제품명</span>
                            </div>
                        </div>
                        {
                            productArray
                            ?
                            <SetInputGroups 
                            productArray={productArray} 
                            sigongArray={sigongArray}
                            inputBox={inputBox}
                            jaegoArray={jaegoArray}
                            setJaego={setJaego}
                            />
                            :
                            <InputGroups 
                            inputBox={inputBox}
                            jaegoArray={jaegoArray}
                            setJaego={setJaego}
                            />
                        }
                       
                        
                    </div>
                    <div style={TopBorderBottom} className="mb-2">주의사항 및 관리 방법</div>
                    <div className="mb-4"><span style={redFont}>입력되지 않은 항목은 시공확인서에 노출되지 않습니다.</span></div>
                    <div className="mb-4">
                        <label className="mb-3">[썬팅]</label>
                        <input name="suntint" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={suntint}/>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">[블랙박스]</label>
                        <input name="blackbox" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={blackbox}/>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">[유리막 코팅]</label>
                        <input name="coating" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={coating}/>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">[PPF]</label>
                        <input name="ppf" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={ppf}/>
                    </div>
                    <div className="mb-4">
                        <label className="mb-3">[디테일 코팅]</label>
                        <input name="detail" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={detail}/>
                    </div>
                    <div className="mb-5">
                        <label className="mb-3">[전면 유리 보호 필름]</label>
                        <input name="film" type="text" className="form-control" placeholder="입력해주세요" onChange={onChange} value={film}/>
                    </div>
                    <div className="mb-5">
                        
                        {
                            productArray
                            ?
                            <>
                            <span className="btn btn-primary finishBtn modidi" onClick={modify}>완료</span>
                            <div className="btn btn-primary finishBtn mt-3" onClick={goPage}>작업내역 상세보기</div>
                            </>
                            :
                            <span className="btn btn-primary finishBtn" onClick={insert}>완료</span>
                        }
                        
                    </div>
                </div>
                                
            </Container>
        </>
    );
}

export default CustomerInfo;